<div class="page-container">
  <app-toolbar [title]="'CALLS.ADD_CALL.TITLE' | translate"></app-toolbar>
  <div class="page">
    @if (data !== null) {
      <form class="form-container" #dataForm="ngForm" (ngSubmit)="addCall()">
        <br />
        <mat-form-field subscriptSizing="dynamic">
          <mat-label translate="COMMON.MEETING_NAME"></mat-label>
          <input matInput required name="name" [(ngModel)]="data.name" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label translate="COMMON.MEETING_LINK"></mat-label>
          <input matInput required name="link" [(ngModel)]="data.link" />
        </mat-form-field>

        <div class="datetime-duration-picker">
          <app-datetime-picker
            [(ngModel)]="data.date"
            name="date"
            [isDateInvalid]="isDateTooFarInPast(data.date)"
            errorMessageKey="VALIDATION.DATE_TOO_FAR_IN_PAST"
          ></app-datetime-picker>

          <mat-form-field class="duration-container" subscriptSizing="dynamic">
            <mat-label translate="COMMON.DURATION"></mat-label>
            <div class="duration-picker">
              <button mat-icon-button mat-small-icon-button (click)="$event.preventDefault(); decreaseDuration()" [disabled]="decreaseDurationButtonDisabled">
                <mat-icon>remove</mat-icon>
              </button>
              <div class="duration-display">
                <input matInput readonly [(ngModel)]="data.duration" name="duration" />
                <span class="duration-label">{{ 'COMMON.MINUTE_ABBREVIATION' | translate }}</span>
              </div>
              <button mat-icon-button mat-small-icon-button (click)="$event.preventDefault(); increaseDuration()" [disabled]="increaseDurationButtonDisabled">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </mat-form-field>
        </div>

        @if (organizationUsersWithoutCurrentUser$ | async; as result) {
          @if (result.isSuccess) {
            <app-selection
              labelKey="COMMON.ADDITIONAL_CALL_OWNERS"
              idField="id"
              nameField="fullName"
              [options]="addFullNameToUserList(result.data!)"
              (selectionChange)="onUserSelectionChange($event)"
            ></app-selection>
            <div class="disclaimer-box">
              <mat-icon class="disclaimer-icon">info</mat-icon>
              {{ 'UPLOAD_CALL.DISCLAIMER' | translate }}
            </div>
          }
        }

        <div class="documents">
          <div class="document">
            <h4 translate="COMMON.CUSTOM_DOCUMENT_UPLOAD"></h4>
            <app-file-upload
              type="custom-document"
              [acceptedFileTypes]="customDocumentExtensions"
              [maxSize]="customDocumentMaxSize"
              (fileChange)="data.customDocumentUploadInfo = $event"
            ></app-file-upload>
          </div>
          <div class="document agenda">
            <h4 translate="COMMON.AGENDA_UPLOAD"></h4>
            <mat-form-field>
              <mat-label translate="CALLS.AGENDA_TYPE"></mat-label>
              <mat-select name="agenda-type" [(ngModel)]="data.agendaType">
                <mat-option [value]="null">{{ 'COMMON.NONE' | translate }}</mat-option>
                <mat-option [value]="'SINGLE'">{{ 'CALLS.AGENDA_TYPE_SINGLE' | translate }}</mat-option>
                <mat-option [value]="'MULTIPLE'">{{ 'CALLS.AGENDA_TYPE_MULTIPLE' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
            @if (data.agendaType === 'MULTIPLE') {
              <div>
                <mat-icon class="warning-icon">warning</mat-icon>
                <span class="warning-text">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.MULTI_AGENDA_WARNING' | translate }}</span>
              </div>
            } @else if (data.agendaType === 'SINGLE') {
              @if (currentUser$ | async; as user) {
                <div class="document agenda">
                  <app-file-upload
                    type="agenda"
                    [acceptedFileTypes]="agendaExtensions"
                    [maxSize]="agendaMaxSize"
                    (fileChange)="data.agendaUploadInfo = $event"
                  ></app-file-upload>
                </div>
              }
            }
          </div>
        </div>

        <br />
        <h3 translate="MINUTES_STYLING.TITLE"></h3>
        <app-minutes-styling [data]="data" (update)="updateMinutesStyling($event)"></app-minutes-styling>
        @if (addCallMutation.result$ | async; as result) {
          @if (result.isPending) {
            <app-spinner></app-spinner>
          } @else {
            <button
              mat-flat-button
              color="primary"
              type="submit"
              name="submit"
              [disabled]="!dataForm.valid || data.duration === 0 || isDateTooFarInPast(data.date)"
              translate="COMMON.ADD_CALL"
            ></button>
          }
        }
      </form>
    }
  </div>
</div>
